import useSoftReload from '@/lostHooks/softReload/useSoftReload';
import { SOFT_RELOAD_PRESET } from '@/lostHooks/softReload/softReloadPresets';
import { exitGame } from '@/utilities/helpers/exitGame';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/store/useStore';
import { useShallow } from 'zustand/react/shallow';
import { incrementGeolocationRetryCount } from '@/store/actions';
import { GeolocationErrorType } from '@/store/slices/geolocation/types';
import { MAX_NDBS_RETRIES } from '@/geolocation/constants';
import config from '@/config';

const GeolocationErrorActionButtons = () => {
  const { reload } = useSoftReload();
  const { t } = useTranslation();

  const { errorType, retryCount } = useStore(
    useShallow((s) => ({
      errorType: s.geolocationError.type,
      retryCount: s.retryCount,
    })),
  );

  // NDBS errors are retryable up to a bounded number of attempts. Once the budget
  // is spent we swap the retry CTA for a "contact support" CTA. Non-NDBS errors
  // (e.g. PLC/general) keep their existing retry behaviour.
  const isNdbsError = errorType === GeolocationErrorType.NDBS;
  const retriesExhausted = isNdbsError && retryCount >= MAX_NDBS_RETRIES;

  const retry = () => {
    incrementGeolocationRetryCount();
    reload({ preset: SOFT_RELOAD_PRESET.GEOLOCATION_RETRY });
  };

  const contactSupport = () => {
    window.open(config?.geoComply?.help, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="modal__buttons" data-testid="geolocation_error_buttons">
      <button
        className="btn__dismiss"
        data-testid="geolocation-dismiss-button"
        onKeyDown={() => exitGame()}
        onClick={() => exitGame()}
      >
        {t('PLCNotInstalled.dismiss')}
      </button>
      {retriesExhausted ? (
        <button
          className="btn btn__link btn-main"
          data-testid="geolocation_contact_support"
          onKeyUp={() => contactSupport()}
          onClick={() => contactSupport()}
        >
          {t('geocomply.notAllowed.contactSupport')}
        </button>
      ) : (
        <button
          className="btn btn__link btn-main"
          data-testid="geolocation_retry"
          onKeyUp={() => retry()}
          onClick={() => retry()}
        >
          {t('geocomply.locationError.retry')}
        </button>
      )}
    </div>
  );
};
export default GeolocationErrorActionButtons;
